import { useState } from 'react'


import TrunkList from "./TrunkList"
import Wizard from "./Wizard"

///////////////////////////////////////////////////////////////////////////////////////////////////
//  SIP trunk configuration                                                                      //
//                                                                                               //
//  +=========================================================================================+  //
//  |  TrunkList                                                                              |  //
//  +=========================================================================================+  //
//                                                                                               //
//  +=========================================================================================+  //
//  |  Wizard                                                                                 |  //
//  |  +-----------------------------------------------------------------------------------+  |  //
//  |  |  Profile selection page                                                           |  |  //
//  |  +-----------------------------------------------------------------------------------+  |  //
//  |  +----------------------------------+ +----------------------------------------------+  |  //
//  |  |  SIP parameters config page for  | |  SIP gateway for VAA                         |  |  //
//  |  |  - Public                        | +----------------------------------------------+  |  //
//  |  |  - WebRTC                        | +----------------------------------------------+  |  //
//  |  |                                  | |  SIP prefix for VAA                          |  |  //
//  |  +----------------------------------+ +----------------------------------------------+  |  //
//  |  +-----------------------------------------------------------------------------------+  |  //
//  |  |  Summary page                                                                     |  |  //
//  |  +-----------------------------------------------------------------------------------+  |  //
//  +=========================================================================================+  //
//                                                                                               //
///////////////////////////////////////////////////////////////////////////////////////////////////


///////////////////////////
// SIP trunk configuration
///////////////////////////
const SipTrunkConfig = () => {
    const [sipProfileState, setSipProfileState] = useState(0); // 0: SIP trunk display page, 1: Wizard launched
    const [prerequisites, setPrerequisites] = useState({}); // Prerequisites usable where needed

    // Switch to choose what component has to be active
    function handleClick(pageSelect) {
        setSipProfileState(pageSelect);
    }

    // Prrequisites handler
    function handlePrerequisites(prereq)
    {
        setPrerequisites(prereq);
    }

    if (sipProfileState === 0) {
        return (<TrunkList onAddSIPProfile={() => handleClick(1)} onSetPrerequisites={handlePrerequisites} />);
    } else {
        return (<Wizard onFinish={() => handleClick(0)} prerequisites={prerequisites} />);
    };
}

export default SipTrunkConfig
